<template>
  <div class="d-flex flex-column pa-10">
    <i-btn class="mb-5" color="primary" @click="a = true"
      >01-2_채용지원_사진등록</i-btn
    >
    <BasePopup
      v-model="a"
      title="사진 등록"
      width="600"
      confirmButtonText="저장"
    >
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 pt-3 d-flex justify-center">
          <v-avatar class="avatar-wrap" size="160">
            <v-icon
              size="48"
              color="#d8d8d8"
              class="material-icons-outlined mdi"
              >person</v-icon
            >
          </v-avatar>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 d-flex justify-center mt-5">
          <i-btn class="mr-3" style="font-weight:600" outlined>
            사진삭제
          </i-btn>
          <i-btn outlined color="primary" style="font-weight:600">
            사진등록
          </i-btn>
        </v-col>
      </v-row>
      <v-row class="my-0 mx-n8">
        <v-col cols="12" class="mt-8 pa-8 mb-n6 text-center info-wrap">
          <p class="info-desc">
            {{ $t('공고한 기간내에 프로필 사진을 등록해주세요.') }}
          </p>
          <p class="mt-4 info-title d-flex align-center justify-center">
            <v-icon
              size="20"
              color="#000000"
              class="material-icons-outlined mdi"
              >date_range</v-icon
            ><span>등록기간</span
            ><span class="ml-3 date point-blue">2022.08.01 - 2022.08.10</span>
          </p>
        </v-col>
      </v-row>
    </BasePopup>
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="b = true"
      >02-2_채용지원_전형안내및결과확인_참석여부선택</i-btn
    >
    <BasePopup v-model="b" title="안내" width="600">
      <h2 class="modal-title">면접전형 안내드립니다.</h2>
      <p class="modal-desc mt-4">
        국회는 헌법 또는 법률에 특별한 규정이 없는 한 재적의원 과반수의 출석과
        출석의원 과반수의 찬성으로 의결한다. 가부동수인 때에는 부결된 것으로
        본다. 행정각부의 설치·조직과 직무범위는 법률로 정한다. 모든 국민은
        양심의 자유를 가진다. 국무총리는 국회의 동의를 얻어 대통령이 임명한다.
        국가는 재해를 예방하고 그 위험으로부터 국민을 보호하기 위하여 노력하여야
        한다.
      </p>
      <h3 class="modal-sub-title mt-12 d-flex align-center">
        <v-icon size="20" color="#000000" class="material-icons-outlined mdi"
          >date_range</v-icon
        ><span class="ml-1">면접일정</span>
      </h3>
      <div class="table-wrap mt-2">
        <table class="table-top no-line-type">
          <colgroup>
            <col width="20%" />
            <col width="30%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th>면접장소</th>
              <td colspan="3">서울특별시 서초구 사평대로 84 이수화학빌딩</td>
            </tr>
            <tr>
              <th class="">면접날짜</th>
              <td>2022.08.30</td>
              <th>면접시간</th>
              <td>14:00</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #actions="{close}">
        <v-card-actions
          class="base-popup-content-actions d-flex justify-space-between"
        >
          <v-col cols="6" class="py-0 pl-0" style="padding-right:5px;">
            <i-btn
              block
              outlined
              color="#d5d8dc"
              @click="close()"
              elevation="0"
            >
              <span class="black--text">불참석</span>
            </i-btn>
          </v-col>
          <v-col cols="6" class="py-0 pr-0" style="padding-left:5px;">
            <i-btn block color="#087ef7" @click="close()" elevation="0">
              <span class="white--text">참석</span>
            </i-btn>
          </v-col>
        </v-card-actions>
      </template>
    </BasePopup>

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="c = true"
      >02-3_채용지원_전형안내및결과확인_참석여부선택_참석확정</i-btn
    >
    <BasePopup
      v-model="c"
      title="안내"
      width="600"
      :useCancel="false"
      confirmButtonText="닫기"
      confirmButtonClass="btn-type-09"
    >
      <p class="modal-desc mt-4">
        면접 <strong class="point-blue">참석</strong>으로 확정되셨습니다. 확정된
        면접일정은 다음과 같습니다.
      </p>
      <h3 class="modal-sub-title mt-6 d-flex align-center">
        <v-icon size="20" color="#000000" class="material-icons-outlined mdi"
          >date_range</v-icon
        ><span class="ml-1">면접일정</span>
      </h3>
      <div class="table-wrap mt-2">
        <table class="table-top no-line-type">
          <colgroup>
            <col width="20%" />
            <col width="30%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th>면접장소</th>
              <td colspan="3">서울특별시 서초구 사평대로 84 이수화학빌딩</td>
            </tr>
            <tr>
              <th class="">면접날짜</th>
              <td>2022.08.30</td>
              <th>면접시간</th>
              <td>14:00</td>
            </tr>
          </tbody>
        </table>
      </div>
    </BasePopup>

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="d = true"
      >02-4_채용지원_전형안내및결과확인_참석여부선택_불참석확정</i-btn
    >
    <BasePopup
      v-model="d"
      title="확인"
      width="600"
      :useCancel="false"
      confirmButtonText="닫기"
      confirmButtonClass="btn-type-09"
    >
      <p class="modal-desc mt-4">
        해당 면접에 <strong class="point-red">불참석</strong>으로
        확정되셨습니다. 지원해주셔서 감사합니다.
      </p>
      <h3 class="modal-sub-title mt-6 d-flex align-center">
        <v-icon size="20" color="#000000" class="material-icons-outlined mdi"
          >date_range</v-icon
        ><span class="ml-1">면접일정</span>
      </h3>
      <div class="table-wrap mt-2">
        <table class="table-top no-line-type">
          <colgroup>
            <col width="20%" />
            <col width="80%" />
          </colgroup>
          <tbody>
            <tr>
              <th>참석여부</th>
              <td>불참석</td>
            </tr>
          </tbody>
        </table>
      </div>
    </BasePopup>

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="e = true"
      >02-5_채용지원_전형안내및결과확인_결과안내_불합격</i-btn
    >
    <BasePopup v-model="e" width="600" :useCancel="false">
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 py-3">
          <div class="img-wrap">
            <v-img
              width="240"
              height="91"
              class="mx-auto"
              src="~@/img/result_img_failur.png"
            ></v-img>
          </div>
        </v-col>
      </v-row>
      <h2 class="modal-title text-center mt-6">결과 안내드립니다.</h2>
      <p class="modal-sub-title normal text-center mt-13">
        1차 면접 전형에 <strong class="point-red">불합격</strong>하셨습니다.
      </p>
      <p class="modal-desc pb-14 mt-11">
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
      </p>
    </BasePopup>

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="f = true"
      >02-6_채용지원_전형안내및결과확인_결과안내_합격</i-btn
    >
    <BasePopup v-model="f" width="600" :useCancel="false">
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 py-3">
          <div class="img-wrap">
            <v-img
              width="240"
              height="91"
              class="mx-auto"
              src="~@/img/result_img_pass.png"
            ></v-img>
          </div>
        </v-col>
      </v-row>
      <h2 class="modal-title text-center mt-6">결과 안내드립니다.</h2>
      <p class="modal-sub-title normal text-center mt-13">
        1차 면접 전형에 <strong class="point-blue">합격</strong>하셨습니다.
      </p>
      <p class="modal-desc pb-14 mt-11">
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
        이러저러한 내용입니다. 이러저러한 내용입니다. 이러저러한 내용입니다.
      </p>
    </BasePopup>

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="g = true"
      >03-2_채용지원_과제제출및추가정보입력_과제제출</i-btn
    >
    <BasePopup
      title="과제 제출"
      v-model="g"
      width="600"
      :useCancel="false"
      confirmButtonText="저장"
    >
      <v-row class="ma-0 pa-0 inner-padding">
        <v-col cols="12" class="pa-0 pt-4 text-center">
          <v-avatar color="#f2f2f2" size="100">
            <div class="accept-icon-wrap">
              <v-img class="mx-auto" src="~@/img/assignment_img_upload.png" />
            </div>
          </v-avatar>
        </v-col>
      </v-row>
      <p class="modal-desc text-center mt-3">
        서류전형 1차 과제에 대해 안내드립니다.<br />
        제출기간 내에 과제 파일을 업로드 하여 주시기 바랍니다.
      </p>
      <v-row class="my-0 mx-n8">
        <v-col cols="12" class="mt-4 px-8 py-6 mb-n6 text-center info-wrap">
          <p class="info-title d-flex align-center justify-center">
            <v-icon
              size="20"
              color="#000000"
              class="material-icons-outlined mdi"
              >date_range</v-icon
            ><span>제출기간</span
            ><span class="ml-3 date point-blue">2022.08.01 - 2022.08.10</span>
          </p>
        </v-col>
      </v-row>
      <v-row class="my-0 mx-n8">
        <v-col
          cols="12"
          class="mt-11 px-8 py-6 mb-n6 text-center info-wrap d-flex"
        >
          <i-text-field
            label="파일명"
            outlined
            class="box-type-01"
            hide-details="auto"
            dense
            single-line
          ></i-text-field>
          <i-btn elevation="0" color="#465166" class="d-block ml-2" height="38"
            ><span class="white--text">첨부</span></i-btn
          >
          <i-btn
            elevation="0"
            color="#d5d8dc"
            outlined
            class="d-block ml-2"
            height="38"
            ><span class="black--text">삭제</span></i-btn
          >
        </v-col>
      </v-row>
    </BasePopup>

    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->

    <i-btn color="primary" class="mb-5" @click="h = true"
      >03-4_채용지원_과제제출및추가정보입력_부가정보입력_작성하기</i-btn
    >
    <BasePopup title="부가정보 입력" v-model="h" width="600">
      <h2 class="modal-title">부가정보를 입력해주세요.</h2>
      <p class="modal-desc mt-4">
        국회는 헌법 또는 법률에 특별한 규정이 없는 한 재적의원 과반수의 출석과
        출석의원 과반수의 찬성으로 의결한다. 가부동수인 때에는 부결된 것으로
        본다. 행정각부의 설치·조직과 직무범위는 법률로 정한다. 모든 국민은
        양심의 자유를 가진다. 국무총리는 국회의 동의를 얻어 대통령이 임명한다.
        국가는 재해를 예방하고 그 위험으로부터 국민을 보호하기 위하여 노력하여야
        한다.
      </p>
      <v-row class="my-0 mx-n8">
        <v-col cols="12" class="mt-10 px-8 py-6 mb-n6 text-center info-wrap">
          <p class="info-title d-flex align-center justify-center">
            <v-icon
              size="20"
              color="#000000"
              class="material-icons-outlined mdi"
              >date_range</v-icon
            ><span>작성기간</span
            ><span class="ml-3 date point-blue">2022.08.01 - 2022.08.10</span>
          </p>
        </v-col>
      </v-row>
      <template #actions="{close}">
        <v-card-actions
          class="base-popup-content-actions d-flex justify-center"
        >
          <i-btn @click="close" elevation="0" color="#087ef7" width="300">
            <span class="white--text">작성하기</span>
          </i-btn>
        </v-card-actions>
      </template>
    </BasePopup>
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <i-btn color="primary" class="mb-5" @click="i = true"
      >03-5_채용지원_과제제출및추가정보입력_부가정보입력_작성동의하기</i-btn
    >
    <BasePopup title="부가정보 입력" v-model="i" width="600">
      <h2 class="modal-title">개인정보 처리방침 동의</h2>
      <p class="modal-desc mt-4 pa-5">
        국회는 헌법 또는 법률에 특별한 규정이 없는 한 재적의원 과반수의 출석과
        출석의원 과반수의 찬성으로 의결한다. 가부동수인 때에는 부결된 것으로
        본다. 행정각부의 설치·조직과 직무범위는 법률로 정한다. 모든 국민은
        양심의 자유를 가진다. 국무총리는 국회의 동의를 얻어 대통령이 임명한다.
        국가는 재해를 예방하고 그 위험으로부터 국민을 보호하기 위하여 노력하여야
        한다.
      </p>
      <div class="agree-wrap">
        <p class="all-agree mt-5 d-flex align-center checked">
          <v-icon size="24" class="material-icons-outlined mdi">done</v-icon
          ><span class="ml-2">모두 동의하기</span>
        </p>
        <ul class="agree-list mb-4">
          <li class="d-flex align-center checked">
            <v-icon size="24" class="material-icons-outlined mdi">done</v-icon
            ><span class="ml-2">개인정보처리방침에 동의합니다.</span
            ><span class="required-txt">(필수)</span>
          </li>
          <li class="d-flex align-center">
            <v-icon size="24" class="material-icons-outlined mdi">done</v-icon
            ><span class="ml-2">이러저러한 방침에 동의합니다.</span
            ><span class="required-txt">(필수)</span>
          </li>
        </ul>
      </div>
      <template #actions="{close}">
        <v-card-actions
          class="base-popup-content-actions d-flex justify-space-between"
        >
          <v-col cols="6" class="py-0 pl-0" style="padding-right:5px;">
            <i-btn
              block
              outlined
              color="#d5d8dc"
              @click="close()"
              elevation="0"
            >
              <span class="black--text">취소</span>
            </i-btn>
          </v-col>
          <v-col cols="6" class="py-0 pr-0" style="padding-left:5px;">
            <i-btn block color="#087ef7" @click="close()" elevation="0">
              <span class="white--text">확인</span>
            </i-btn>
          </v-col>
        </v-card-actions>
      </template>
    </BasePopup>
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <i-btn color="primary" class="mb-5" @click="j = true"
      >03-8_채용지원_과제제출및추가정보입력_부가정보입력_부가정보</i-btn
    >
    <BasePopup title="부가정보 입력" v-model="j" width="600">
      <v-tabs v-model="tab">
        <v-tab>가족정보</v-tab>
        <v-tab>부가정보</v-tab>
        <v-tab>파일업로드</v-tab>
      </v-tabs>
      <v-tabs-slider color="black"></v-tabs-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          가족정보탭
        </v-tab-item>
        <v-tab-item>
          부가정보
        </v-tab-item>
        <v-tab-item>
          <v-form>
            <v-row class="ma-0 bd-T-2px bd-B-2px">
              <v-col class="pa-0 pl-4 col-auto head-title">
                성적증명서
              </v-col>
              <v-col class="pa-0">
                <div class="px-6 py-3 d-flex align-center">
                  <i-text-field
                    label="파일명"
                    outlined
                    class="box-type-01"
                    hide-details="auto"
                    dense
                    single-line
                  ></i-text-field>
                  <i-btn elevation="0">삭제</i-btn>
                  <i-btn elevation="0"
                    ><span class="white--text">첨부</span></i-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>
      </v-tabs-items>

      <template #actions="{close}">
        <v-card-actions class="base-popup-content-actions d-flex">
          <i-btn @click="close" class="ml-auto" elevation="0">
            닫기
          </i-btn>
          <i-btn @click="close" elevation="0" color="#087ef7">
            <span class="white--text">최종제출</span>
          </i-btn>
        </v-card-actions>
      </template>
    </BasePopup>
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
  </div>
</template>

<script>
import BasePopup from '@/components/common/BasePopup.vue';
export default {
  components: { BasePopup },
  data() {
    return {
      tab: 0,
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      f: false,
      g: false,
      h: false,
      i: false,
      j: false,
    };
  },
};
</script>

<style>
p {
  margin-bottom: 0px !important;
}
ul,
li {
  list-style: none;
}
.point-blue {
  color: #087ef7;
}
.point-red {
  color: #ff5c5c;
}
.avatar-wrap {
  border: solid 1px #d8d8d8;
}
.info-wrap {
  background-color: #fafafa;
}
.info-wrap .info-title,
.modal-sub-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  letter-spacing: -0.32px;
  color: #000;
}
.modal-sub-title.normal {
  font-weight: normal;
  line-height: 1.38;
  letter-spacing: -0.32px;
  color: #363c43;
}
/* .info-wrap .info-title .point-blue {
  color: #087ef7;
} */
.info-wrap .info-desc,
.modal-desc {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.57;
  letter-spacing: -0.28px;
  color: #363c43;
}
.modal-title {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.67;
  letter-spacing: -0.36px;
  color: #363c43;
}

/* table */
table {
  width: 100%;
  margin-bottom: 16px;
  border-collapse: collapse;
  border-spacing: 0px;
}
th {
  background: #f2f2f2;
  border-bottom: 1px solid #d5d8dc;
}
tr,
th,
td {
  padding: 8px 18px;
  font-size: 14px;
  border-right: 1px solid #ddd;
}
th {
  font-size: 14px;
  font-weight: 700;
  padding: 8px 0px;
}
tbody {
  background: #ffffff;
  padding: 11px 20px;
}
tbody td {
  display: table-cell;
  vertical-align: middle;
  border-bottom: 1px solid #e0e0e0;
  font-size: 12px;
  word-break: keep-all;
}
table.table-top {
  border-top: 2px solid #d5d8dc;
}
table.no-line-type,
table.no-line-type tr,
table.no-line-type th,
table.no-line-type th:last-child,
table.no-line-type td,
table.no-line-type td:last-child {
  border-right: 0px;
}

.img-wrap {
  padding-top: 36px;
  padding-bottom: 13px;
}
.agree-wrap .mdi {
  color: #cacdcf;
}
.agree-wrap .all-agree {
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.57;
  letter-spacing: -0.28px;
  color: #363c43;
}
.agree-wrap .agree-list {
  padding-left: 0px !important;
  margin-top: 14px;
}
.agree-wrap .agree-list li {
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: -0.28px;
  color: #363c43;
}
.agree-wrap .agree-list li:first-child {
  margin-top: 0px;
}
.agree-wrap .all-agree.checked .mdi,
.agree-wrap .agree-list li.checked .mdi {
  color: #087ef7;
}

.agree-wrap .agree-list li .required-txt {
  color: #9ca3ab;
}

/* 파일 업로드  */
.bd-T-2px {
  border-top: 2px solid #d5d8dc !important;
}

.bd-B-2px {
  border-bottom: 2px solid #d5d8dc !important;
}
.head-title {
  width: 220px;
  font-size: 14px;
  font-weight: 700;
  line-height: 62px;
  letter-spacing: -0.28px;
  color: #363c43;
  background-color: #f7f7f7;
}
</style>
